/* eslint
    no-async-promise-executor: "warn",
    dot-notation: "off"
*/

import { IDataMapper, IEasyfyEvent, IEasyfyEventExporter } from '@shared/easyfy.events/easyfy.eventdata';

/* Klaviyo Exporter class */
export class KlaviyoEventExporter implements IEasyfyEventExporter {
  mapper: IDataMapper;

  WithMapper(mapper: IDataMapper): void {
    this.mapper = mapper;
  }

  RegisterEvent(event: IEasyfyEvent): Promise<any> {
    return new Promise<void>(async (resolve) => {
      if (this.mapper) {
        const eventData = this.mapper.MapEventData(event);
        await this.PushToKlaviyo(eventData);
      }
      resolve();
    });
  }

  async PushToKlaviyo(klaviyoEvent: any): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      if (klaviyoEvent) {
        KlaviyoEventExporter.EnsureKlaviyoStub();
        window['klaviyo'].push(["track", klaviyoEvent.event, klaviyoEvent.data]);

        // console.group('%c Klaviyo ', 'color: #bada55');
        // console.dir(window['klaviyo']);
        // console.groupEnd();
        resolve(true);
      }
      else {
        resolve(false);
      }
    });
  }

  // Mirrors Klaviyo's own onsite bootstrap snippet (previously loaded synchronously from
  // _KlaviyoScript.cshtml, now loaded asynchronously and consent-gated via a GTM tag). On a
  // product page our "Viewed Product" event can fire before that GTM tag runs, so whichever
  // side gets here first must set up the real queueing Proxy - a plain array stub here would
  // make GTM's own "if (!window.klaviyo)" guard skip setup permanently, leaving window.klaviyo
  // stuck as a dumb array with no identify()/track() functions for the rest of the page's life.
  static EnsureKlaviyoStub(): void {
    if (window['klaviyo']) {
      return;
    }

    window['_klOnsite'] = window['_klOnsite'] || [];

    try {
      window['klaviyo'] = new Proxy({}, {
        get(target, property) {
          if (property === 'push') {
            return (...args: any[]) => window['_klOnsite'].push(...args);
          }
          return (...args: any[]) => {
            const callback = typeof args[args.length - 1] === 'function' ? args.pop() : undefined;
            return new Promise((resolve) => {
              window['_klOnsite'].push([property, ...args, (result: any) => {
                callback?.(result);
                resolve(result);
              }]);
            });
          };
        }
      });
    }
    catch {
      window['klaviyo'] = window['klaviyo'] || [];
      window['klaviyo'].push = (...args: any[]) => window['_klOnsite'].push(...args);
    }
  }
}
